'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _survey = require('./survey.component');

var _survey2 = _interopRequireDefault(_survey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var surveyModule = _angular2.default.module('app.containers.survey', [_angularUiRouter2.default]).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('survey', {
    url: '/survey',
    template: '<survey></survey>'
  });
}).component('survey', _survey2.default);

exports.default = surveyModule;


/** WEBPACK FOOTER **
 ** ./client/app/containers/survey/survey.js
 **/